import { Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from './Layout'
import { HomePage } from '@/pages/HomePage'
import { NIST80022Page } from '@/pages/NIST80022Page'
import { SP80090BPage } from '@/pages/SP80090BPage'
import { TunableBiasPage } from '@/pages/TunableBiasPage'
import { GaussianPage } from '@/pages/GaussianPage'
import { APIDocsPage } from '@/pages/APIDocsPage'

export function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="sp800-22" element={<NIST80022Page />} />
        <Route path="sp800-90b" element={<SP80090BPage />} />
        <Route path="tunable-bias" element={<TunableBiasPage />} />
        <Route path="gaussian" element={<GaussianPage />} />
        <Route path="api-docs" element={<APIDocsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  )
}
